import { PublishOffIcon } from './PublishOffIcon';

/**
 * author: Michael Irigoyen
 * id 57375CB0-5F7F-492E-BB25-3EE90669FE6D
 * name publish-off
 * version: 6.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/publish-off.svg
 * tags
 * - Arrow 
 */
export const PublishDisabledIcon = PublishOffIcon;
export default PublishDisabledIcon